import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgTeamFilled24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5V3.5C16.5 3.22386 16.2761 3 16 3H8C7.72386 3 7.5 3.22386 7.5 3.5V4.5H16.5ZM19.5 4.5C21.1569 4.5 22.5 5.84315 22.5 7.5V16.5C22.5 18.1569 21.1569 19.5 19.5 19.5H4.5C2.84315 19.5 1.5 18.1569 1.5 16.5V7.5C1.5 5.84315 2.84315 4.5 4.5 4.5H6V3.5C6 2.39543 6.89543 1.5 8 1.5H16C17.1046 1.5 18 2.39543 18 3.5V4.5H19.5Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeamFilled24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=TeamFilled24.svg.js.map
